import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function NaviMumbaiToGoaCabService() {



    const cardData = {





keyword: "Navi Mumbai to Goa Cab Service",

headingDescription: "Shreesha Tours & Travels offers comfortable and reliable Navi Mumbai to Goa Cab Service for family vacations, corporate travel, honeymoon trips, group tours, and leisure journeys. We provide chauffeur-driven Sedan, SUV, Ertiga, Kia Carens, Innova, Innova Crysta, Tempo Traveller, and premium vehicles for a smooth long-distance journey from Navi Mumbai to Goa. With experienced drivers, clean and well-maintained cars, transparent pricing, doorstep pickup, flexible one-way and round-trip options, and 24/7 customer support, we ensure a safe and enjoyable travel experience. Whether you are planning a beach holiday, family tour, or Goa sightseeing trip, Shreesha Tours & Travels provides dependable cab booking services with complete comfort and convenience.",

topPlaces: [
  {
    title: "Baga Beach Goa",
    description: "Baga Beach is one of Goa's most popular tourist destinations, famous for beach shacks, water sports, nightlife, seafood restaurants, and beautiful coastal views. Travelers enjoy activities like parasailing, jet skiing, and relaxing near the Arabian Sea. It is an ideal destination for families, couples, and groups visiting Goa from Navi Mumbai."
  },
  {
    title: "Calangute Beach Goa",
    description: "Calangute Beach, popularly known as the Queen of Beaches, attracts thousands of tourists with its lively atmosphere, shopping streets, restaurants, water activities, and scenic shoreline. The location offers easy access to nearby attractions and is a preferred stay area for travelers booking Navi Mumbai to Goa cab services."
  },
  {
    title: "Dudhsagar Waterfalls Goa",
    description: "Dudhsagar Waterfalls is one of India's most spectacular waterfalls, surrounded by lush forests and natural beauty. Visitors can enjoy jeep safaris, trekking experiences, and breathtaking views of the waterfall. It is a must-visit destination for adventure lovers and nature enthusiasts traveling to Goa."
  },
  {
    title: "Fort Aguada Goa",
    description: "Fort Aguada is a historic Portuguese fort known for its ancient architecture, lighthouse, sea views, and panoramic coastal scenery. The fort provides excellent photography opportunities and showcases Goa's rich colonial history. It is one of the most visited heritage attractions in North Goa."
  },
  {
    title: "Panaji Goa",
    description: "Panaji is the capital city of Goa and offers a mix of heritage, culture, and modern attractions. Visitors can explore Fontainhas Latin Quarter, Mandovi River, churches, markets, and local restaurants. The city provides a unique experience of Portuguese influence combined with traditional Goan culture."
  },
  {
    title: "Palolem Beach Goa",
    description: "Palolem Beach is a peaceful South Goa destination known for its beautiful crescent-shaped coastline, calm waters, beach huts, kayaking, dolphin trips, and relaxing environment. It is perfect for travelers who prefer a quieter holiday experience away from crowded tourist areas."
  },
  {
    title: "Vagator Beach Goa",
    description: "Vagator Beach is famous for red cliffs, sunset views, beach cafés, and nearby Chapora Fort. It attracts tourists looking for scenic locations, photography spots, and a vibrant beach atmosphere. Travelers can enjoy beautiful views of the Arabian Sea while exploring North Goa."
  },
  {
    title: "Candolim Beach Goa",
    description: "Candolim Beach offers a peaceful and premium beach experience with luxury resorts, restaurants, water sports, and relaxing seaside surroundings. Located near Fort Aguada and Calangute, it is a convenient location for tourists exploring popular attractions in North Goa."
  },
  {
    title: "Chapora Fort Goa",
    description: "Chapora Fort is a historic hilltop fort offering stunning views of Vagator Beach and the Arabian Sea. Known for its scenic sunset views and Bollywood connection, the fort is a favorite attraction among tourists and photographers visiting Goa."
  },
  {
    title: "South Goa Beaches",
    description: "South Goa is known for peaceful beaches, luxury resorts, natural beauty, and relaxing coastal experiences. Popular locations include Colva Beach, Benaulim Beach, Agonda Beach, and Varca Beach. Travelers booking Navi Mumbai to Goa cabs often explore South Goa for a calm and memorable holiday."
  }
],


"services": [
  {
    "name": "Navi Mumbai to Goa Cab Service",
    "description": "Book Navi Mumbai to Goa Cab Service for comfortable and reliable long-distance travel with professional chauffeurs and well-maintained AC vehicles. Choose from Sedan, Swift Dzire, Ertiga, Innova, Innova Crysta, SUV, Kia Carens, and luxury cab options for Goa vacations, family trips, corporate travel, sightseeing, airport transfers, and one-way or round-trip journeys."
  },
  {
    "name": "Navi Mumbai to Goa Cab",
    "description": "Reserve Navi Mumbai to Goa Cab for a smooth and convenient journey from Navi Mumbai to Goa with experienced drivers and premium vehicles. Enjoy doorstep pickup, affordable pricing, comfortable seating, and hassle-free travel for personal and holiday trips."
  },
  {
    "name": "Navi Mumbai to Goa Taxi Service",
    "description": "Choose Navi Mumbai to Goa Taxi Service for safe and affordable interstate transportation with professional chauffeurs. Get clean AC taxis, flexible booking options, transparent fares, and reliable travel support throughout your Goa journey."
  },
  {
    "name": "Navi Mumbai to Goa Taxi",
    "description": "Book Navi Mumbai to Goa Taxi for private and comfortable travel with experienced drivers and spacious vehicles. Perfect for families, couples, corporate travelers, and tourists looking for a convenient road trip experience."
  },
  {
    "name": "Navi Mumbai to Goa One Way Cab",
    "description": "Hire Navi Mumbai to Goa One Way Cab for economical drop taxi service without return charges. Enjoy flexible pickup timings, professional drivers, and comfortable vehicles for a direct journey to Goa."
  },
  {
    "name": "Navi Mumbai to Goa Round Trip Cab",
    "description": "Reserve Navi Mumbai to Goa Round Trip Cab for holiday vacations, sightseeing tours, and return journeys. Enjoy flexible travel plans, experienced chauffeurs, comfortable AC vehicles, and convenient pickup and drop facilities."
  },
  {
    "name": "Navi Mumbai to Goa Outstation Cab",
    "description": "Book Navi Mumbai to Goa Outstation Cab for safe and comfortable highway travel with premium vehicles and professional drivers. Ideal for family vacations, business trips, and long-distance travel requirements."
  },
  {
    "name": "Navi Mumbai to Goa Innova Cab",
    "description": "Choose Navi Mumbai to Goa Innova Cab for spacious and comfortable travel with families and groups. Enjoy extra luggage space, premium seating, AC comfort, and smooth rides with experienced chauffeurs."
  },
  {
    "name": "Navi Mumbai to Goa Innova Crysta Cab",
    "description": "Book Navi Mumbai to Goa Innova Crysta Cab for luxury road trips with premium interiors and superior comfort. Perfect for families, VIP travelers, and passengers looking for a premium travel experience."
  },
  {
    "name": "Navi Mumbai to Goa Ertiga Cab",
    "description": "Reserve Navi Mumbai to Goa Ertiga Cab for affordable family travel with spacious seating and comfortable interiors. Enjoy reliable chauffeur-driven service for long-distance Goa journeys."
  },
  {
    "name": "Navi Mumbai to Goa Sedan Cab",
    "description": "Hire Navi Mumbai to Goa Sedan Cab for budget-friendly and comfortable travel with clean AC sedan cars. Suitable for couples, small families, and corporate passengers."
  },
  {
    "name": "Navi Mumbai to Goa SUV Cab",
    "description": "Book Navi Mumbai to Goa SUV Cab for spacious and premium travel with extra luggage capacity. Ideal for groups and families who need comfortable long-distance transportation."
  },
  {
    "name": "Navi Mumbai to Goa Private Cab",
    "description": "Choose Navi Mumbai to Goa Private Cab for personalized travel with a dedicated vehicle and professional chauffeur. Enjoy privacy, comfort, flexible stops, and a relaxed road trip experience."
  },
  {
    "name": "Navi Mumbai to Goa Family Cab",
    "description": "Reserve Navi Mumbai to Goa Family Cab for safe and comfortable vacation travel with loved ones. Get spacious vehicles, experienced drivers, and convenient travel options for families."
  },
  {
    "name": "Navi Mumbai to Goa Cab Package",
    "description": "Book Navi Mumbai to Goa Cab Package for customized travel solutions including one-way trips, round trips, sightseeing, and holiday transportation. Enjoy affordable packages with comfortable vehicles."
  },
  {
    "name": "Navi Mumbai to Goa Tour Package by Cab",
    "description": "Choose Navi Mumbai to Goa Tour Package by Cab for complete holiday travel with private vehicles and professional chauffeurs. Explore Goa attractions comfortably with flexible schedules and customized routes."
  },
  {
    "name": "Affordable Navi Mumbai to Goa Cab",
    "description": "Book Affordable Navi Mumbai to Goa Cab for quality travel at competitive prices. Enjoy reliable service, clean vehicles, professional drivers, and comfortable journeys without compromising safety."
  },
  {
    "name": "Luxury Cab Navi Mumbai to Goa",
    "description": "Reserve Luxury Cab Navi Mumbai to Goa for premium travel with high-comfort vehicles and professional chauffeurs. Perfect for business travelers, VIP guests, and special occasions."
  },
  {
    "name": "AC Cab Navi Mumbai to Goa",
    "description": "Hire AC Cab Navi Mumbai to Goa for comfortable highway travel in clean air-conditioned vehicles. Enjoy smooth rides with experienced drivers and reliable service."
  },
  {
    "name": "Best Navi Mumbai to Goa Cab Service",
    "description": "Choose the Best Navi Mumbai to Goa Cab Service for safe, punctual, and comfortable transportation. Get premium vehicles, experienced chauffeurs, affordable fares, and excellent travel support."
  },
  {
    "name": "Online Navi Mumbai to Goa Cab Booking",
    "description": "Complete Online Navi Mumbai to Goa Cab Booking for quick confirmation and hassle-free reservations. Select your preferred vehicle, pickup location, and travel plan with easy booking facilities."
  },
  {
    "name": "Navi Mumbai Airport to Goa Cab",
    "description": "Book Navi Mumbai Airport to Goa Cab for direct airport pickup and comfortable transfer services. Enjoy professional drivers, luggage assistance, flight-friendly pickups, and premium AC vehicles."
  },
  {
    "name": "Vashi to Goa Cab Service",
    "description": "Reserve Vashi to Goa Cab Service for convenient travel from Vashi to Goa with doorstep pickup and experienced chauffeurs. Enjoy comfortable vehicles for holidays and business trips."
  },
  {
    "name": "Nerul to Goa Cab",
    "description": "Book Nerul to Goa Cab for reliable outstation travel with clean AC cars and professional drivers. Enjoy smooth transportation from Nerul to Goa."
  },
  {
    "name": "Belapur to Goa Cab",
    "description": "Choose Belapur to Goa Cab for comfortable long-distance journeys with experienced chauffeurs and well-maintained vehicles. Suitable for family trips and corporate travel."
  },
  {
    "name": "Panvel to Goa Cab",
    "description": "Reserve Panvel to Goa Cab for affordable and convenient travel with flexible booking options. Enjoy safe highway travel with professional drivers."
  },
  {
    "name": "Kharghar to Goa Cab",
    "description": "Book Kharghar to Goa Cab Service for comfortable vacation travel with reliable vehicles and experienced chauffeurs. Perfect for families and tourists traveling to Goa."
  },
  {
    "name": "Airoli to Goa Cab",
    "description": "Hire Airoli to Goa Cab for smooth interstate transportation with premium AC vehicles and professional drivers. Enjoy hassle-free travel from Airoli to Goa."
  },
  {
    "name": "Ghansoli to Goa Cab",
    "description": "Reserve Ghansoli to Goa Cab for safe and comfortable travel with private vehicles and experienced chauffeurs. Get reliable cab service for your Goa trip."
  },
  {
    "name": "CBD Belapur to Goa Taxi",
    "description": "Book CBD Belapur to Goa Taxi for convenient travel with clean vehicles, affordable pricing, and professional drivers. Enjoy comfortable transportation for personal and holiday journeys."
  },
  {
    "name": "Kharghar to Goa Cabs Service",
    "description": "Choose Kharghar to Goa Cabs Service for reliable and affordable travel options. Enjoy Sedan, SUV, Innova, Ertiga, Innova Crysta, and premium cab choices with experienced chauffeurs."
  }
],
"tableData": [
  ["Navi Mumbai to Goa Cab Service", "Navi Mumbai to Goa Cab"],
  ["Navi Mumbai to Goa Taxi Service", "Navi Mumbai to Goa Taxi"],
  ["Navi Mumbai to Goa One Way Cab", "Navi Mumbai to Goa Round Trip Cab"],
  ["Navi Mumbai to Goa Outstation Cab", "Navi Mumbai to Goa Innova Cab"],
  ["Navi Mumbai to Goa Innova Crysta Cab", "Navi Mumbai to Goa Ertiga Cab"],
  ["Navi Mumbai to Goa Sedan Cab", "Navi Mumbai to Goa SUV Cab"],
  ["Navi Mumbai to Goa Private Cab", "Navi Mumbai to Goa Family Cab"],
  ["Navi Mumbai to Goa Cab Package", "Navi Mumbai to Goa Tour Package by Cab"],
  ["Affordable Navi Mumbai to Goa Cab", "Luxury Cab Navi Mumbai to Goa"],
  ["AC Cab Navi Mumbai to Goa", "Best Navi Mumbai to Goa Cab Service"],
  ["Online Navi Mumbai to Goa Cab Booking", "Navi Mumbai Airport to Goa Cab"],
  ["Vashi to Goa Cab Service", "Nerul to Goa Cab"],
  ["Belapur to Goa Cab", "Panvel to Goa Cab"],
  ["Kharghar to Goa Cab", "Airoli to Goa Cab"],
  ["Ghansoli to Goa Cab", "CBD Belapur to Goa Taxi"],
  ["Kharghar to Goa Cabs Service", ""]
],



whychoose: [
  {
    WhyChooseheading: "Reliable Navi Mumbai to Goa Cab Service",
    WhyChoosedescription: "Shreesha Travels offers comfortable Navi Mumbai to Goa cab services for families, couples, tourists, corporate travellers, and groups. Enjoy a private and relaxing journey from Navi Mumbai to Goa with professional chauffeurs and well-maintained vehicles."
  },
  {
    WhyChooseheading: "Direct Door-to-Door Goa Travel",
    WhyChoosedescription: "Get convenient pickup from your home, office, hotel, or preferred location in Navi Mumbai and direct drop service at your Goa destination including hotels, resorts, beaches, and popular tourist areas."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options for Goa Trips",
    WhyChoosedescription: "Choose from Sedan Cars, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles according to your group size, luggage, and comfort requirements."
  },
  {
    WhyChooseheading: "Perfect for Family Holidays & Group Tours",
    WhyChoosedescription: "Our Navi Mumbai to Goa taxi service is ideal for family vacations, honeymoon trips, weekend getaways, corporate tours, destination weddings, and sightseeing holidays."
  },
  {
    WhyChooseheading: "One-Way & Round Trip Cab Booking",
    WhyChoosedescription: "Book a one-way cab to Goa or choose a round-trip package with flexible return schedules, sightseeing stops, waiting options, and customized travel plans."
  },
  {
    WhyChooseheading: "Experienced Drivers for Mumbai-Goa Highway",
    WhyChoosedescription: "Our professional chauffeurs are familiar with Maharashtra-Goa routes and highways, ensuring safe driving, timely service, and a comfortable long-distance travel experience."
  },
  {
    WhyChooseheading: "Clean & Comfortable Vehicles",
    WhyChoosedescription: "Every cab is regularly serviced, sanitized, air-conditioned, and inspected before every journey to provide passengers with a safe, hygienic, and enjoyable travel experience."
  },
  {
    WhyChooseheading: "Book Navi Mumbai to Goa Cab Service with Shreesha Travels",
    WhyChoosedescription: "Enjoy transparent pricing, quick booking support, professional chauffeur service, and reliable transportation for your Navi Mumbai to Goa journey."
  }
]

};

const faqData = [
  {
    question: "Can I book a cab from Navi Mumbai to Goa?",
    answer: "Yes, you can book a private cab from Navi Mumbai to Goa for a comfortable and direct journey."
  },
  {
    question: "Do you provide one-way cab service from Navi Mumbai to Goa?",
    answer: "Yes, one-way taxi services are available for passengers travelling directly from Navi Mumbai to Goa."
  },
  {
    question: "Can I book a round-trip cab for Goa?",
    answer: "Yes, round-trip Goa cab packages are available with flexible return timings and customized travel schedules."
  },
  {
    question: "Which vehicles are available for Navi Mumbai to Goa travel?",
    answer: "We provide Sedan Cars, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles."
  },
  {
    question: "Is this cab service suitable for family vacations?",
    answer: "Yes, spacious vehicles like Ertiga, Kia Carens, Innova, and Innova Crysta are ideal for families travelling to Goa."
  },
  {
    question: "Can I travel to North Goa and South Goa locations?",
    answer: "Yes, our cabs provide doorstep drop service to major Goa locations including Panaji, Calangute, Baga, Candolim, Anjuna, Margao, and other areas."
  },
  {
    question: "Can I add sightseeing stops during my Goa trip?",
    answer: "Yes, customized Goa travel plans with sightseeing stops can be arranged according to your itinerary."
  },
  {
    question: "How is the Navi Mumbai to Goa cab fare calculated?",
    answer: "The fare depends on vehicle type, travel distance, trip type, toll charges, parking fees, route, and additional requirements."
  },
  {
    question: "Are overnight journeys available from Navi Mumbai to Goa?",
    answer: "Yes, overnight travel options are available according to your preferred departure time."
  },
  {
    question: "How can I book Navi Mumbai to Goa Cab Service with Shreesha Travels?",
    answer: "Share your pickup location, travel date, passenger count, destination in Goa, and preferred vehicle to receive a customized quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohit Sharma",
    feedback: "Our Navi Mumbai to Goa trip was excellent. The cab was comfortable, the driver was professional, and the complete journey was smooth and enjoyable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Anjali Desai",
    feedback: "We booked a Goa cab for our family holiday and had a wonderful experience. The vehicle was spacious, clean, and the service was reliable.",
    rating: 5
  }
];





    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Navi Mumbai to Goa Cab Service",
  "image": "https://www.shreeshatravels.com/assets/images/navi-mumbai-to-goa-cab-service.webp",
  "description":
    "Book Navi Mumbai to Goa Cab Service with Shreesha Tours & Travels for comfortable and reliable outstation taxi services. We provide Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for Goa trips, beach vacations, family travel, sightseeing tours, one-way journeys, round trips, and long-distance travel from Navi Mumbai to Goa with experienced drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/navi-mumbai-to-goa-cab-service"
  }
};





    return (
        <div>

<Helmet>
  <title>Navi Mumbai to Goa Cab Service | Goa Taxi Booking | +91 8355835813</title>

  <meta
    name="description"
    content="Book Navi Mumbai to Goa Cab Service with Shreesha Travels for safe and comfortable outstation taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta for Goa trips, one-way cab, round trips, family vacations, sightseeing tours, and 24x7 cab booking."
  />

  <meta
    name="keywords"
    content="Navi Mumbai to Goa Cab Service, Navi Mumbai to Goa Cab, Navi Mumbai to Goa Taxi Service, Navi Mumbai to Goa Taxi, Navi Mumbai to Goa One Way Cab, Navi Mumbai to Goa Round Trip Cab, Navi Mumbai Goa Outstation Taxi, Goa Tour Cab from Navi Mumbai, Navi Mumbai Goa Car Rental, Goa Taxi Booking Navi Mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/112.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default NaviMumbaiToGoaCabService;